import {HttpClient} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {Service} from 'src/app/enums/service.enum';
import {environment} from 'src/environments/environment';
import {ApplicationPackage} from '../../../enums/application-package.enum';

@Injectable({
  providedIn: 'root',
})
export class PosterService {
  private readonly posterServiceApi = environment.endPoint + ApplicationPackage.CMS_VOD + Service.POSTER_SERVICE;

  constructor(private http: HttpClient) {}

  deletePosterById(posterId: number): Observable<number> {
    return this.http.delete<number>(this.posterServiceApi + `/${posterId}`, {responseType: 'text' as 'json'});
  }
}
